export const passwordRequired = 'Bitte gib ein gültiges Passwort ein.';

export const generic = {
    email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    required: 'Bitte fülle dieses Feld aus.',
    valid: 'Bitte gib einen gültigen Wert ein.',
    salary: 'Bitte gib eine Zahl ein',
    unknown: 'Unbekannter Fehler',
    range: ([min, max]) => `Bitte gib eine Zahl zwischen ${min} und ${max} ein.`,
    min: (min) => `Bitte gib mindestens ${min} Zeichen ein.`,
    max: (max) => `Du kannst nur ${max} Zeichen eingeben.`,
    min_numeric: (min) => `Bitte gib mindestens ${min} ein.`,
    max_numeric: (max) => `Du kannst nur ${max} Zeichen eingeben.`,
};

export const userForm = {
    /* eslint-disable */
    'hash_differentiates': 'Der Hash-Wert stimmt nicht überein. Bitte starte den Vorgang erneut.',
    'password_incorrect': 'Das eingegebene Passwort ist nicht korrekt.',
    'new_password_same_as_old_one': 'Dein neues Passwort muss sich von deinem aktuellen unterscheiden.',
    'password_not_complex_enough': 'Dein neues Passwort entspricht nicht den oben genannten Kriterien.',
    'passwords_differentiate': 'Die eingegebenen Passwörter stimmen nicht überein.',
    'email_password_combo': 'Falscher Benutzer oder falsches Passwort.',
    'user_exists': 'Diese E-Mail-Adresse ist bereits registriert.',
    'email_change_failed': 'Es ist ein Fehler aufgetreten, E-Mail-Adresse wurde nicht geändert. ' +
        'Bitte versuch es zu einem späteren Zeitpunkt noch einmal.',
    'password_change_failed': 'Es ist ein Fehler aufgetreten, Passwort wurde nicht geändert. ' +
        'Bitte versuch es zu einem späteren Zeitpunkt noch einmal.',
    /* eslint-enable */
};
